import * as Yup from "yup";
import i18n from "../../../../i18n";

const schema = Yup.object({
  email: Yup.string()
    .email(i18n.t("resetPassword.errorMessages.invalidEmail"))
    .required(i18n.t("resetPassword.errorMessages.missingEmail")),
});

export default schema;
